import { Action } from '@ngrx/store';
import { BackButton } from '../lib/lib';
import { PayloadAction } from '../lib/payload-action';

const initialState = new BackButton();

export class BackButtonActionType {
  static readonly BACK_BUTTON_ENABLED = 'BackButtonEnabled';
  static readonly BACK_BUTTON_VISIBLE = 'BackButtonVisible';
  static readonly BACK_BUTTON_TEXT_SET = 'BackButtonTextSet';
  static readonly BACK_BUTTON_TEXT_RESET = 'BackButtonTextReset';
}

export function backButtonStateReducer(state = initialState, action: PayloadAction) {
  let isChanged = true;
  switch (action.type) {
    case BackButtonActionType.BACK_BUTTON_ENABLED:
      state.enabled = action.payload;
      break;
    case BackButtonActionType.BACK_BUTTON_VISIBLE:
      state.visible = action.payload;
      break;
    case BackButtonActionType.BACK_BUTTON_TEXT_SET:
      state.text = action.payload;
      break;
    case BackButtonActionType.BACK_BUTTON_TEXT_RESET:
      state.resetText();
      break;
    default:
      isChanged = false;
      break;
  }
  return isChanged ? BackButton.fromOther(state) : state;
}
